import React from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router-dom";
import { LandingPage } from "./pages/LandingPage/LandingPage";
import { SearchResultsPage } from "./pages/SearchResultsPage/SearchResultsPage";
import { ArticlePage } from "./pages/ArticlePage/ArticlePage";
import { CategoryPage } from "./pages/CategoryPage/CategoryPage";
// import { SubcategoryPage } from "./pages/SubcategoryPage/SubcategoryPage"; // TO DO: This will be added in Phaese 2 when subcategories have their own dedicated page
import { Search } from "./components/Search";
import { Card, Column, Columns, StackSection } from "@origin-digital/ods-core";
import { content } from "./content";
import { isLandingPath } from "./helpers/routes";
import { useSyncActionBar } from "./hooks/useSyncActionBar";

export const BASE_PATH = "/help-support";

export const PATHS = {
  landing: BASE_PATH,
  search: `${BASE_PATH}/search`,
  article: `${BASE_PATH}/:categoryUri/:subcategoryUri/:slug`,
  subcategory: `${BASE_PATH}/:categoryUri/:subcategoryUri`,
  category: `${BASE_PATH}/:categoryUri`,
};

const SubcategoryRedirect: React.FC = () => {
  const { categoryUri } = useParams();
  return <Navigate to={`${BASE_PATH}/${categoryUri}`} replace />;
};

export const AppRoutes: React.FC = () => {
  const { pathname } = useLocation();
  useSyncActionBar();
  const isLandingPage = isLandingPath(pathname);

  return (
    <>
      <div>
        <StackSection
          backgroundColor="cardBackground"
          width="xlarge"
          space="none"
          hideGutter={false}
          paddingY="none"
        >
          <Card
            backgroundColor="transparent"
            paddingXSpecific={{
              xs: isLandingPage ? "medium" : "none",
              lg: "none",
            }}
            paddingYSpecific={{
              xs: isLandingPage ? "xxxlarge" : "xxlarge",
              sm: "xxlarge",
              lg: "xxxlarge",
            }}
          >
            {isLandingPage ? (
              <Columns collapseBelow="lg" alignX="center">
                <Column width="2/3">
                  <Search
                    heading={content.search.heading}
                    searchPlaceholder={content.search.placeholder}
                  />
                </Column>
              </Columns>
            ) : (
              <Search searchPlaceholder={content.search.placeholder} />
            )}
          </Card>
        </StackSection>
      </div>
      <Routes>
        <Route path={PATHS.landing} element={<LandingPage />} />
        <Route path={PATHS.search} element={<SearchResultsPage />} />
        <Route path={PATHS.article} element={<ArticlePage />} />
        <Route path={PATHS.subcategory} element={<SubcategoryRedirect />} />
        <Route path={PATHS.category} element={<CategoryPage />} />
        <Route path="*" element={<Navigate to={BASE_PATH} replace />} />
      </Routes>
    </>
  );
};
